export { default } from './convict-config';
